import ReportsLocalList from "./components/ReportsLocalList";
import SupervisorReports from "./components/SupervisorReports";
import ViewReport from "./components/ViewReport";
import ViewReportGeneralDrowsiness from "./components/ViewReportGeneralDrowsiness";
import ViewReportHoteliers from "./components/ViewReportHoteliers";
import ViewReportImages from "./components/ViewReportImages";
import ViewReportRoomDrowsiness from "./components/ViewReportRoomDrowsiness";
import ReportsSupervisorApp from "./ReportsSupervisorApp";

const ReportsSupervisorConfig = {
	settings: {
		layout: {},
	},
	routes: [
		// {
		// 	path: "reportsSupervisor",
		// 	element: <ReportsSupervisorApp />,
		// },
		{
			path: "supervisorLocals",
			element: <ReportsSupervisorApp />,
		},
		{
			path: "supervisorLocals/:localId",
			element: <ReportsLocalList />,
		},
		{
			path: "/supervisorLocals/viewImages/:reportId",
			element: <ViewReportImages />,
		},
		{
			path: "/supervisorLocals/view/:reportId",
			element: <ViewReport/>
		},
		{
			path: "supervisorLocals/viewGeneralDrowsiness/:reportId",
			element: <ViewReportGeneralDrowsiness />
		},
		{
			path: "supervisorLocals/viewRoomDrowsiness/:reportId",
			element: <ViewReportRoomDrowsiness />
		},
		{
			path: "supervisorLocals/viewHoteliers/:reportId",
			element: <ViewReportHoteliers />
		},
		{
			path: "reportsSupervisor/",
			element: <SupervisorReports />
		},
	],
};

export default ReportsSupervisorConfig;
